module.exports = __webpack_public_path__ + "img/add.06d7a9a6.png";